import React, { useMemo, useState } from 'react';
import WorkOrderTable from '../WorkOrderTable';
import { BUYER_WO_FILTERS_ORDER } from '../../utils/WorkOrderUtils';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import WorkOrderFiltersWrapper from '../work_order_filters_wrapper/WorkOrderFiltersWrapper';

function WorkOrdersActiveIndexPage({}) {
	return (
		<WorkOrderFiltersWrapper>
			{(defaultFilters) => (
				<WorkOrderTable
					handleQueryParams
					preAppliedFilters={{ hasBuyerArchived: false }}
					filterConfig={{ filters: BUYER_WO_FILTERS_ORDER }}
					initialFilters={defaultFilters}
				/>
			)}
		</WorkOrderFiltersWrapper>
	);
}

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(WorkOrdersActiveIndexPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(Form.create()(ComponentWithoutUserType));
